<template>
  <el-row>
    <el-col class="column-container">
      <div class="label-container">
        <div class="field-container">
          <label class="form-label">
            {{ $t('CampaignReport_RepeatInput_Label') }}
          </label>
          <form-item-i-tooltip placement="top-start">
            <template #content>
              <span>
                {{ $t('CampaignReport_RepeatInput_Tooltip') }}
              </span>
            </template>
          </form-item-i-tooltip>
        </div>
        <p class="description">
          {{ $t('CampaignReport_RepeatInput_Description') }}
        </p>
      </div>
      <div class="field-container">
        <rest-form-item prop="base_runs" :rules="rules">
          <el-input
            placeholder="∞"
            v-model.number="model.base_runs"
            style="width: 90px"
            :disabled="disabled"
          />
          <form-item-i-tooltip v-if="disabled" placement="top-start">
            <template #content>
              <span>
                {{ $t('CampaignReport_Disabled_Input_Tooltip') }}
              </span>
            </template>
          </form-item-i-tooltip>
        </rest-form-item>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem.vue'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'

export default {
  name: 'RepeatInput',

  components: { FormItemITooltip, RestFormItem },

  props: {
    model: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      rules: { validator: this.validateBaseRuns, trigger: 'blur' }
    }
  },

  methods: {
    validateBaseRuns: (rule, value, callback) => {
      if (value !== null && value !== '') {
        if (typeof value !== 'number') {
          callback(new Error('Value must be a number'))
        } else if (value < 1) {
          callback(new Error('Value must be greater than 0'))
        }
      }

      callback()
    }
  }
}
</script>
<style scoped>
.column-container {
  display: flex;
  column-gap: 41px;
  margin-bottom: 32px;
}
.label-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
}
.field-container {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.field-container div {
  margin-bottom: 0;
}
.description {
  color: #7e8596;
  font-size: 12px;
  line-height: 18px;
}
.form-label {
  color: #5c6374;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/report/RepeatInput.vue